import { Configuration, DefaultApi } from 'poshwatch_ts_client';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { API_BASE_URL } from "./config.ts";

export const createApiClient = async (): Promise<DefaultApi> => {
  let token: string | undefined;

  try {
    const auth = getAuth();
    await new Promise((resolve) => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        unsubscribe();
        resolve(user);
      });
    });

    const user = auth.currentUser;
    if (user) {
      token = await user.getIdToken();
    }
  } catch (error) {
    console.error("Error getting auth token:", error);
  }

  const configuration = new Configuration({
    baseOptions: {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
      }
    }
  });

  return new DefaultApi(
    configuration,
    API_BASE_URL,
  );
};
